import {Injectable} from '@angular/core';
import {TreeNode} from "primeng/api";
import {BehaviorSubject} from "rxjs";

@Injectable(
    {providedIn: 'root'},
)
export class SubtitleService {
    additionalTitle$: BehaviorSubject<string> = new BehaviorSubject<string>(''); // Observable to track node changes
};
